import { ref, reactive, computed } from 'vue'

export const menu = reactive({})

export const modals = reactive({})

export const locale = ref('gb')

export const date = ref('')

export const dollar = ref(1)

export const goal = ref(0)

export const participants = reactive([])

export const players = computed(() => {
  return participants.filter((participant) => participant.day1 || participant.day2)
})

export const staff = computed(() => {
  return participants.filter((participant) => participant.staff)
})

export const spectators = computed(() => {
  return participants.filter((participant) => participant.spectator) //.concat({ country: "ru", nick: "Maickl" });
})

export default { participants, players, staff, spectators }

const dataUrl = location.hostname === 'localhost' ? 'https://quakelife.ru/factory/lan/1/data' : 'data'

fetch(dataUrl)
  .then((res) => res.json())
  .then((data = {}) => {
    dollar.value = data.dollar || 75
    goal.value = data.goal || 300000
    date.value = data.date || '2020-10-03T07:00:00Z'
    participants.push(...data.participants)
  })
